import { useEffect, useRef } from 'react';

export const usePrevious = value => {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
};

/**
 * use this just for debug purpose
 */
export const useHasChanged = (val, key) => {
    const prevVal = usePrevious(val);
    const changed = prevVal !== val;

    if (changed) {
        console.log(key, 'has changed', prevVal, val);
    }

    return changed;
};
